import './sentrySetup';
import { createRoot } from 'react-dom/client';
import Cookie from '@globalwebindex/platform2-lib/src/cookies';
import './fonts.css';
import './index.css';
import './globals.css';
import logger from './utils/logger';
import App from './components/App';

const cookie = new Cookie(null);
cookie.write('gwilogger', '1');

const onLoad = () => {
  if (location.pathname === '/health') {
    return renderHeathCheck();
  }
  renderInit();
};

const renderInit = () => {
  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  } else {
    logger.error('container not found');
  }
};

const renderHeathCheck = () => {
  const container = document.getElementById('healthCheck');
  if (container) {
    const root = createRoot(container);
    root.render(<span>OK</span>);
  }
};

window.addEventListener('load', onLoad);
